import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Link } from 'react-router-dom';
import close from '../Asset/close.svg';
import { Form, Modal } from 'react-bootstrap';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getUserInfo, getDashboard } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Maintenance() {
  const dashboard = sessionStorage.getItem('Dashboards') ? getDashboard() : [];
  let userObj = getUserInfo();
  let tdate = new Date();
  var yyyy = String(tdate.getFullYear());
  let [sessOut, setSessOut] = useState(false);
  let [pmDone, setPmDone] = useState([]);
  let [pmDue, setPmDue] = useState([]);
  let [cate, setCate] = useState([]);
  let [subCate, setSubCate] = useState([]);
  let [siteList, setSiteList] = useState([]);
  let [allAseet, setAllAsset] = useState([]);
  let [dropdownData, setDropDownData] = useState({
    asset_equipmentType: [
      { name: "" },
    ]
  });
  let [years, setYears] = useState([]);
  let [filterDefault, setFilterDefault] = useState({
    501: {
      equipmentID: "",
      equipmentType: "",
      siteID: "",
      year: yyyy,
      productCategoryID: "",
      productSubCategoryID: "",
    },
    502: {
      equipmentID: "",
      equipmentType: "",
      siteID: "",
      year: yyyy,
      productCategoryID: "",
      productSubCategoryID: "",
    }
  })

  let [filterHis, setFilterHis] = useState({
    501: {
      equipmentID: "",
      equipmentType: "",
      siteID: "",
      year: yyyy,
      productCategoryID: "",
      productSubCategoryID: "",
    },
    502: {
      equipmentID: "",
      equipmentType: "",
      siteID: "",
      year: yyyy,
      productCategoryID: "",
      productSubCategoryID: "",
    }
  })


  useEffect(() => {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    let abortController = new AbortController();
    let today = new Date();
    var yyyy = today.getFullYear();

    let tempy = [];
    for (let i = 0; i < 3; i++) {
      tempy.push(yyyy - i);
    }
    setYears(tempy);

    if (globObj && globObj != 'undefined') {
      setFilter(globObj);
      saveGlobelFilter('store', globObj);
    }
    else {
      if (dashboard.indexOf(501) >= 0) {
        getPmDone(filterHis[501]);
      }
      if (dashboard.indexOf(502) >= 0) {
        getPmDue(filterHis[502]);
      }
    }


    getProductCategory();
    getDropDown();
    getSiteList();

    return () => {
      abortController.abort();
    }
  }, [])

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setSubCate([]);
    setFilter({
      equipmentID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      productCategoryID: "",
      productSubCategoryID: "",
    });
  };
  const handleShow = (dashID) => {
    setFilterDash(dashID);
    setFilter(filterHis[dashID]);
    if (filterHis[dashID].siteID == "") {
      getAssetList();
    }
    else {
      getEquipmentBySite(filterHis[dashID].siteID);
    }
    if (filterHis[dashID].productCategoryID != "") {
      getProductSubCategory(filterHis[dashID].productCategoryID)
    }
    setShow(true);
  }

  function clearFilter(dashID) {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    setAllAsset([]);

    if (globObj && globObj != 'undefined') {
      sessionStorage.removeItem('GloberFilter');
      getPmDone(filterDefault[501]);
      getPmDue(filterDefault[502]);
      setFilterHis({
        501: filterDefault[501],
        502: filterDefault[502]
      });
    }
    else {
      setFilterHis({ ...filterHis, [dashID]: filterDefault[dashID] });
      if (dashID == 501) {
        getPmDone(filterDefault[501]);
      }
      if (dashID == 502) {
        getPmDue(filterDefault[502]);
      }
    }

    handleClose();

  }


  let [filterDash, setFilterDash] = useState(null);
  let [filter, setFilter] = useState({
    equipmentID: "",
    equipmentType: "",
    siteID: "",
    year: "",
    productCategoryID: "",
    productSubCategoryID: ""
  });

  function getFilterData(e) {
    if (e.target.name === "productCategoryID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      getProductSubCategory(parseInt(e.target.value));
    }
    else if (e.target.name === "productSubCategoryID" || e.target.name === "siteID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      if (e.target.name === "siteID") {
        getEquipmentBySite(e.target.value);
      }
    }
    else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  }
  function getFilterFields() {
    setFilterHis({ ...filterHis, [filterDash]: filter })
    if (filterDash == 501) {
      getPmDone(filter);
    }
    else {
      getPmDue(filter);
    }
  }


  function getProductCategory() {
    fetch(environment.baseUrl + "getProductCategory?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setCate(resp.data.result.categories);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setCate([]);
        }
      })
    })
  }
  function getProductSubCategory(pid) {
    fetch(environment.baseUrl + "getProductSubCategory?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          "parentID": pid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setSubCate(res.data.result.subCategories);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSubCate([]);
        }
      })
    })
  }
  function getDropDown() {
    fetch(environment.baseUrl + "getDropDown", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "groupName": ["equipmentType"],
        "masterType": ["asset"]
      })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setDropDownData(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setDropDownData({
            asset_equipmentType: [
              { name: "" },
            ]
          })
        }

      })
    })
  }
  function getSiteList() {
    fetch(environment.baseUrl + "getSiteByUserAccount", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setSiteList(resp.data.result.siteList);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setSiteList([]);
        }
      })
    })
  }
  function getAssetList() {
    fetch(environment.baseUrl + "getEquipmentsByUser", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }

  function getEquipmentBySite(sid) {
    fetch(environment.baseUrl + "getEquipmentBySite?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          siteID: sid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }

  function getPmDone(obj) {
    fetch(environment.baseUrl + "pmDoneReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          year: obj.year,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        }
      )
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.pmDone.forEach(element => {
            newTemp.push({ 'name': element[0], 'Counterbalanced Diesel': element[1], "Counterbalanced Electric": element[2], "Warehousing": element[3], "Adjacencies": element[4] })
          });
          setPmDone(newTemp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setPmDone([]);
        }
        handleClose();
      })
    })
  }
  function getPmDue(obj) {
    fetch(environment.baseUrl + "pmDueOverdueReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          year: obj.year,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        }
      )
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.pmDueOverdue.forEach(element => {
            newTemp.push({ name: element[0], "Counterbalanced Diesel": element[1], "Counterbalanced Electric": element[2], "Warehousing": element[3], "Adjacencies": element[4] })
          });

          setPmDue(newTemp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setPmDue([])
        }
        handleClose();
      })
    })
  }
  function saveGlobelFilter(type, obj) {
    let val = {}, filObj;
    if (type == "store") {
      val = obj;
    }
    else {
      sessionStorage.setItem("GloberFilter", JSON.stringify({
        equipmentID: filter.equipmentID ? filter.equipmentID : "",
        equipmentType: filter.equipmentType ? filter.equipmentType : "",
        siteID: filter.siteID ? filter.siteID : "",
        fromDate: filter.fromDate ? filter.fromDate : "",
        toDate: filter.toDate ? filter.toDate : "",
        month: filter.month ? filter.month : "",
        year: filter.year ? filter.year : "",
        productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
        productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
      }));
      val = {
        equipmentID: filter.equipmentID ? filter.equipmentID : "",
        equipmentType: filter.equipmentType ? filter.equipmentType : "",
        siteID: filter.siteID ? filter.siteID : "",
        fromDate: filter.fromDate ? filter.fromDate : "",
        toDate: filter.toDate ? filter.toDate : "",
        month: filter.month ? filter.month : "",
        year: filter.year ? filter.year : "",
        productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
        productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
      };
    }
    filObj = {
      "501": {
        equipmentID: val.equipmentID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year != "" ? val.year : String(yyyy),
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID
      },
      "502": {
        equipmentID: val.equipmentID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year != "" ? val.year : String(yyyy),
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID
      }
    }
    setFilterHis(filObj);
    allApiCall(filObj);
  }
  function allApiCall(req) {
    if (dashboard.indexOf(501) >= 0) {
      getPmDone(req[501]);
    }
    if (dashboard.indexOf(502) >= 0) {
      getPmDue(req[502]);
    }
  }
  return (

    <div className='main-container'>
      <SessionFun show={sessOut}></SessionFun>
      <h4 className='main-heading'>Preventive Maintenance</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Maintenance</p>
      {
        dashboard.indexOf(501) == -1 ? "" :
          <div className="row card-box-block mt-3">
            <div className="col-sm-12 full-col">
              <div className="row">
                <div className="col-sm-10">
                  <h6 className='cardtitle'>Preventive Maintenance Done {":"+filterHis['501'].year}</h6>
                </div>
                <div className="col-sm-2  text-end">
                  <FontAwesomeIcon icon={faBars} onClick={() => handleShow(501)} />
                </div>
              </div>

              <hr />
              {
                pmDone.length ?
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart
                      data={pmDone}
                      barSize={20}
                    >
                      <CartesianGrid vertical={false} strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="Counterbalanced Diesel" fill="#2196F3" />
                      <Bar dataKey="Counterbalanced Electric" fill="#FF9800" />
                      <Bar dataKey="Warehousing" fill="#795548" />
                      <Bar dataKey="Adjacencies" fill="#FFEB3B" />
                    </BarChart>
                  </ResponsiveContainer>
                  :
                  <p className='text-center'><b>No Data Available</b></p>
              }
            </div>
          </div>
      }
      {
        dashboard.indexOf(502) == -1 ? "" :
          <div className="row card-box-block mt-3">
            <div className="col-sm-12 full-col">
              <div className="row">
                <div className="col-sm-10">
                  <h6 className='cardtitle'>Due/Overdue {":"+filterHis['502'].year}</h6>
                </div>
                <div className="col-sm-2  text-end">
                  <FontAwesomeIcon icon={faBars} onClick={() => handleShow(502)} />
                </div>
              </div>
              <hr />
              {
                pmDue.length ?
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart
                      data={pmDue}
                      barSize={20}
                    >
                      <CartesianGrid vertical={false} strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="Counterbalanced Diesel" fill="#2196F3" />
                      <Bar dataKey="Counterbalanced Electric" fill="#FF9800" />
                      <Bar dataKey="Warehousing" fill="#795548" />
                      <Bar dataKey="Adjacencies" fill="#FFEB3B" />
                    </BarChart>
                  </ResponsiveContainer>
                  :
                  <p className='text-center'><b>No Data Available</b></p>
              }
            </div>
          </div>
      }

      <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title> Filter</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className='row  mt-3'>
            <div className='col-sm-4'>
              <Form.Group className="mb-2 " >
                <Form.Label>Year</Form.Label>
                <Form.Select as='select' placeholder='year' name='year' value={filter.year}
                  className="textbox-back" onChange={getFilterData}>
                  <option value="">Select Year</option>
                  {
                    years.map((item, index) =>
                      <option key={index} value={item}>{item}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Category</label>
                <Form.Select as='select' name='productCategoryID' className="textbox-back" value={filter.productCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    cate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Sub Category</label>
                <Form.Select as='select' name='productSubCategoryID' className="textbox-back" value={filter.productSubCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    subCate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Site</label>
                <Form.Select as='select' name='siteID' className="textbox-back" value={filter.siteID} onChange={getFilterData}>
                  <option value="">Select Site</option>
                  {
                    siteList.map((item, index) =>
                      <option key={index} value={item.siteID}>{item.siteName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <label>Equipment ID</label>
                <Form.Select as='select' name='equipmentID' className="textbox-back" value={filter.equipmentID} onChange={getFilterData}>
                  <option value="">Select Equipment ID</option>
                  {
                    allAseet.map((item, index) =>
                      <option key={index} value={item.assetID}>{item.assetID}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Equipment Type</label>
                <Form.Select as='select' name='equipmentType' className="textbox-back" value={filter.equipmentType} onChange={getFilterData}>
                  <option value="">Select Equipment Type</option>
                  {
                    (dropdownData.asset_equipmentType).map((item, index) =>
                      <option key={index} value={item.name}>{item.name}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <button className="btn btn-outline-secondary lo-btn" onClick={() => clearFilter(filterDash)}>
              Reset
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn mx-3" onClick={getFilterFields}>
              Apply
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn" onClick={saveGlobelFilter}>
              Apply All
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Maintenance
